import { Authenticator } from '../../slices/types';

export const authenticator: Authenticator = {
    secret: 'QWASZXQWASZXQWAS',
    qrCodeUri: 'otpauth://totp/account:firstName%20lastName?secret=QWASZXQWASZXQWAS&issuer=issuerName'
};
